module.exports = __webpack_public_path__ + "img/realte-logo.6b7de13d.png";